module.exports = __webpack_public_path__ + "fonts/Moderat Light.7bdbe924.otf";